import { motion } from "framer-motion";
import { MathRichText } from "@/lib/mathRichText";

interface Props {
  data: { type: "tip"; icon?: string; text: string; animation?: string };
  isChildTheme?: boolean;
}

export function ElementTip({ data, isChildTheme }: Props) {
  const child = !!isChildTheme;
  return (
    <motion.div
      className={
        child
          ? "rounded-2xl py-3 px-4 flex gap-3 items-start lp-tip-child shadow-md border border-amber-200/50"
          : "rounded-lg border-l-4 border-blue-500 bg-blue-50 py-2 px-4 flex gap-2"
      }
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      {data.icon && <span className="text-2xl shrink-0 leading-none">{data.icon}</span>}
      <div className={child ? "text-slate-900 text-sm md:text-base font-semibold leading-snug" : "text-slate-700 text-sm"}>
        <MathRichText text={data.text} />
      </div>
    </motion.div>
  );
}
